module.exports = __webpack_public_path__ + "img/acca.a11c8164.jpg";